import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { CopyButton } from '@/components/Ui/CopyButton';
import classes from './Integrations.module.css';

export interface SigningSecretProps {
  secret: string;
  signatureHeader?: string | null;
  onDone: () => void;
}

/** Shown once after create or rotate; the API never returns the secret again. */
export function SigningSecret({ secret, signatureHeader, onDone }: SigningSecretProps) {
  const { t } = useTranslation();
  return (
    <div className={classes.secretArea}>
      <strong>{t('integrations.signing.copyNow')}</strong>
      <div className={classes.secretLine}>
        <code className={classes.secret}>{secret}</code>
        <CopyButton text={secret} />
      </div>
      <span className={classes.help}>
        {signatureHeader
          ? t('integrations.signing.howHeader', { header: signatureHeader })
          : t('integrations.signing.how')}
      </span>
      <Button variant="default" size="xs" onClick={onDone} style={{ alignSelf: 'flex-start' }}>
        {t('integrations.signing.done')}
      </Button>
    </div>
  );
}
